import { bootstrap } from "vue-gtag";

const CONSENT_KEY = "cookie:accepted";

const GTM_ID = "GTM-KDMQ2LCS";
const TIKTOK_PIXEL_ID = "D4A3ARJC77U6M9K6RLS0";
const GA_ID = "G-P4EW046BHY";

// The financier's own pixel is added next to ours once it is fetched (see app.vue)
const facebookPixelIds = ["2210061732650820"];

let loaded = false;

const noop = () => {};

export const hasTrackingConsent = () =>
  localStorage.getItem(CONSENT_KEY) === "true";

export const hasRejectedTracking = () =>
  localStorage.getItem(CONSENT_KEY) === "false";

// The flows call fbq/ttq/gtag directly. Until the visitor accepts cookies
// none of those trackers is loaded, so the calls land on these no-ops instead.
export const installTrackingStubs = () => {
  window.fbq = noop;
  window.ttq = { track: noop, page: noop };
  window.gtag = noop;
};

// The Barion pixel is not held back like the others: nuxt.config.ts loads it on
// every page in its own consent mode, and this passes it the cookie banner answer.
export const setBarionConsent = (accepted) => {
  window.bp?.("consent", accepted ? "grantConsent" : "rejectConsent");
};

const loadScript = (src) => {
  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const loadGoogleTagManager = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  loadScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);
};

const loadGoogleAnalytics = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
};

const loadTikTokPixel = () => {
  // TikTok pixel base code
  !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
    var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
    ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  }(window, document, "ttq");
  window.ttq.load(TIKTOK_PIXEL_ID);
  window.ttq.page();
};

const loadFacebookPixel = () => {
  // Meta pixel base code
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  facebookPixelIds.forEach((pixelId) => window.fbq("init", pixelId));
  window.fbq("track", "PageView");
};

export const loadTrackingScripts = () => {
  if (loaded) {
    return;
  }
  loaded = true;

  // the vendor snippets only install their real queues when these are unset
  delete window.fbq;
  delete window.ttq;

  setBarionConsent(true);
  loadGoogleTagManager();
  loadTikTokPixel();
  loadFacebookPixel();
  loadGoogleAnalytics();
  // vue-gtag (G-KT9B09E9BE), installed with bootstrap: false in plugins/tracking.client.js
  bootstrap();
};

export const addFacebookPixel = (pixelId) => {
  if (!pixelId || facebookPixelIds.includes(pixelId)) {
    return;
  }
  facebookPixelIds.push(pixelId);
  if (loaded) {
    window.fbq("init", pixelId);
    window.fbq("trackSingle", pixelId, "PageView");
  }
};
